import { FC, PropsWithChildren, useEffect, useMemo } from "react";
import { SocketContext } from "@shared/features/socket/Socket.context";
import { socketHandler } from "app/shared/utils";
import useNetConnection from "utils/hooks/useNetConnection";
import { useSelector } from "react-redux";
import { sharedLib } from "@shared/services/shared.service";
import { setIsOnline } from "@shared/common/constants";

const SocketProvider: FC<PropsWithChildren> = ({ children }) => {
  const hasToken = !!useSelector(
    sharedLib.selectors.authentication.selectToken
  );
  const hasUser = !!useSelector(sharedLib.selectors.authentication.selectUser);
  useNetConnection({
    onChange: setIsOnline,
  });

  useEffect(() => {
    if (hasUser && hasToken) {
      socketHandler.initialize();
    } else {
      socketHandler.clear();
    }
  }, [hasUser, hasToken]);

  const contextValue = useMemo(() => {
    return {
      socketHandler,
      enabled: true,
      useIsFocused: () => true,
    };
  }, []);

  return (
    <SocketContext.Provider value={contextValue}>
      {children}
    </SocketContext.Provider>
  );
};

export default SocketProvider;
